import apiWrapper, { create, updateMethod } from './helpers';

export default class AlumniPayment extends apiWrapper('/alumni_payments') {

  static record = opts => create('/alumni_payments/record', opts)

  static appliedOn = updateMethod('/alumni_payments', 'applied_on')

}
